import type { IAppsIosIdentifierFilter } from "app/pages/sales-intelligence/store/find-apps/types";

export enum AppsIdentifiers {
    PackageName = "Package name",
    BundleId = "Bundle ID",
    TrackId = "Track ID",
}

export type IosIdentifierType = keyof IAppsIosIdentifierFilter;
